import React, { lazy } from 'react'

const DiscoveryBanners = lazy(() => import('./DiscoveryBanners/DiscoveryBanners'))
const RootsTechBanners = lazy(() => import('./RootsTechBanners/RootsTechBanners'))
const MissionaryBanner = lazy(() => import('./MissionaryBanner/MissionaryBanner'))

export default function MediaBanners({ bannerGroup = 'rootstech' }) {
  if (bannerGroup === 'rootstech') {
    return <RootsTechBanners />
  }
  if (bannerGroup === 'discovery') {
    return <DiscoveryBanners />
  }
  if (bannerGroup === 'missionary') {
    return <MissionaryBanner />
  }
  return null
}
